"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_TAGS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_TAGS = (0, gql_1.gql)(`
   mutation createTags($reference: ID!, $tags: [TagInput!]!) {
     tags(reference: $reference, tags: $tags) {
        id
        key
        value
      } 
  }
`);
